module.exports = __webpack_public_path__ + "static/media/cipla.ce03c208.svg";